import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { authApi, type MeResponse } from "../api/auth.api.ts";

const ME_QUERY_KEY = ["auth", "me"] as const;

export function useAuth() {
  const q = useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: authApi.me,
    // Always re-fetch on mount so a stale "signed-in" state doesn't survive
    // a session expiring in another tab.
    staleTime: 30_000,
    retry: false,
  });
  return {
    me: q.data,
    isLoading: q.isLoading,
    isError: q.isError,
    refetch: q.refetch,
  };
}

export function useTokenLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => authApi.tokenLogin(token),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => authApi.logout(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}

export function isSignedIn(me: MeResponse | undefined): me is MeResponse & { user: NonNullable<MeResponse["user"]> } {
  return Boolean(me?.user);
}
